import React, {useEffect, useState} from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {NavLink, useLocation} from "react-router-dom";
import links from "../../Modules/Navigation";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";



export default function NavLinks(){

    const _role = useSelector(((state:RootState) => state.auth.role))

    const location = useLocation();
    return(
        <List sx={{marginTop:"20px"}}>
            {links.map((link,index)=>(
                <React.Fragment key={index}>
                    {
                        link.role.indexOf(_role) > -1 ?
                            <NavLink
                                to={link.to}
                                style={({ isActive }) => {
                                    return {
                                        textDecoration:"none",
                                        color: isActive ? "#089BAB" : "#8F95B2",
                                    };
                                }}
                                key={index}
                            >
                                <ListItem
                                    className={(location.pathname===link.to || '/'+location.pathname.split('/')[1]===link.to) ? "sideBar-grediants" : "none"}
                                >
                                    <ListItemIcon
                                        style={{
                                            color:(location.pathname===link.to || '/'+location.pathname.split('/')[1]===link.to) ?"#089BAB":"#8F95B2",
                                            fontSize:(location.pathname===link.to || '/'+location.pathname.split('/')[1]===link.to) ? "36px"  : "32px",
                                        }}
                                    >
                                        {link.Icon}
                                    </ListItemIcon>
                                    <ListItemText primary={link.name}
                                                  disableTypography
                                                  style={{
                                                      letterSpacing:"0.5px",
                                                      fontWeight:(location.pathname===link.to || '/'+location.pathname.split('/')[1]===link.to) ? "700"  : "",
                                                      fontSize:(location.pathname===link.to || '/'+location.pathname.split('/')[1]===link.to)?"24px":"20px",
                                                  }}
                                    />
                                </ListItem>
                            </NavLink>
                            :''
                    }
                </React.Fragment>
            ))}
        </List>
    )
}